export default {"src":"/_next/static/media/pointed-arrow-right-purple.9f872062.svg","height":14,"width":18};